import { TKImgNgoSignup } from "assets/images/jpgs";
import React, { useEffect, useState } from "react";
import CompanyLogo from "shared/CompanyLogo";
import ThankYou from "./ThankYou";
import Details from "./Details";
import Contact from "./Contact";
import Confirmation from "./Confirmation";

const NgoSignup = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [body, setBody] = useState({});

  const handleNextStep = () => {
    if (currentStep === 0) {
      return setCurrentStep((prev) => prev + 1);
    } else if (currentStep === 1) {
      return setCurrentStep((prev) => prev + 1);
    } else if (currentStep === 2) {
      return setCurrentStep((prev) => prev + 1);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const steps = [
    <ThankYou next={handleNextStep} />,
    <Details next={handleNextStep} setBody={setBody} />,
    <Contact next={handleNextStep} body={body} />,
    <Confirmation />,
  ];

  return (
    <div>
      <div className="w-full h-full md:h-screen flex max-md:flex-wrap justify-center items-center gap-8">
        <div className="relative w-[60%] max-md:w-full max-md:h-[500px] h-screen">
          <img
            className="w-full h-full object-cover"
            src={TKImgNgoSignup}
            alt="TK-LoginFrame"
          />
        </div>
        <div className="px-4 w-[40%] h-full overflow-y-scroll md:max-h-[90%] max-md:h-full max-md:w-full">
          <div className="mb-4">
            <CompanyLogo blue />
          </div>
          <div className="w-full">{steps[currentStep]}</div>
        </div>
      </div>
    </div>
  );
};

export default NgoSignup;
